import { Resources } from 'constants/resources';

import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { ReactComponent as RefundChargebackReportIcon } from 'images/refundChargebackReport.svg';
import { Link } from 'react-router-dom';
import { ContextMenuButton } from 'shared/mui/ContextMenu';
import { DEFAULT_TIMEZONE } from 'shared/mui/DatePicker/config/defaultValues';
import {
  DateRangeTimezoneValue,
  DateRangeValue,
} from 'shared/mui/DatePicker/DateTimeRangeTimezonePicker/DateTimeRangeTimezonePicker';
import {
  CompanyBalanceReport,
  MerchantAccountBalanceReport,
  MerchantBalanceReport,
  ProviderBalanceReport,
} from 'types/embedded/balanceReport';
import { formatInputToTimestamp } from 'utils/date';

type Props = {
  appliedDate?: DateRangeValue;
  timezone?: DateRangeTimezoneValue;
  merchantAccount: MerchantAccountBalanceReport;
  merchant: MerchantBalanceReport;
  provider: ProviderBalanceReport;
  company: CompanyBalanceReport;
};

export const ContextMenuRefundChargebackReportLink: React.FC<Props> = ({
  merchantAccount,
  company,
  provider,
  merchant,
  appliedDate,
  timezone,
}) => {
  const { createPathWithQuery } = useCreatePathWithQuery();
  const to = createPathWithQuery(
    {
      resource: Resources.RefundChargebackReport,
      type: 'list',
    },
    {
      filter: {
        merchantAccount: [merchantAccount.id],
        provider: provider.id,
        merchant: merchant.id,
        company: company.id,
        createdAt: {
          gte: formatInputToTimestamp(appliedDate?.[0], { unit: 'seconds' }),
          lte: formatInputToTimestamp(appliedDate?.[1], { unit: 'seconds' }),
        },
        timezone: timezone || DEFAULT_TIMEZONE,
      },
    },
  );

  return (
    <Link style={{ textDecoration: 'none' }} target="_blank" to={to}>
      <ContextMenuButton
        icon={<RefundChargebackReportIcon />}
        label={'Рефанды и чарджбеки\nза выбранный период'}
      />
    </Link>
  );
};
